import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_SPECIAL_RATE_PROVISIONS_SUCCESS = 'GET_SPECIAL_RATE_PROVISIONS_SUCCESS';
export const GET_SPECIAL_RATE_PROVISIONS_CLEAR = 'GET_SPECIAL_RATE_PROVISIONS_CLEAR';

function receive(specialRateProvisions) {
  return {
    type: GET_SPECIAL_RATE_PROVISIONS_SUCCESS,
    specialRateProvisions
  };
}

function clear() {
  return {
    type: GET_SPECIAL_RATE_PROVISIONS_CLEAR
  };
}

export function getSpecialRateProvisions(treatyCountry, hasPensionClaim) {
  return (dispatch) => {
    const promise = () => ApiService
      .getSpecialRateProvisions(treatyCountry, hasPensionClaim)
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, clear, false));
        }
      });
    return promise();
  };
}

export function clearSpecialRateProvisions() {
  return dispatch => dispatch(clear());
}
